import { DatePipe } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import {
  TechTableInfoItemModel,
  TechTableInfoModel,
} from '@tech-models/tech-table-info.model';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { SessionService } from '@tech-services/session.service';
import { Utils } from '@tech-utils/utils';
import { CurrencyPipe, PercentPipe, DashEmptyPipe } from '@techrules/pipelib';
import { TechTableInfoModalComponent } from 'projects/apps/portal-client/src/app/shared/tech-table-info-modal/tech-table-info-modal.component';
import { DeviceDetectorService } from 'projects/libs/tech-lib-portal/src/lib/services/deviceDetectorService.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'tech-portfolio-liabilities',
  templateUrl: './portfolio-liabilities.component.html',
  styleUrls: [
    './portfolio-liabilities.component.scss',
    '../portfolio-data-shared-styles.scss',
  ],
})
export class PortfolioLiabilitiesComponent implements OnInit, OnDestroy {
  isLoading: boolean;
  isMobile: boolean;
  private unsubscribe$ = new Subject<void>();
  data: any;
  dateFormat = this.sessionService.dateFormat
    .replace('DD', 'dd')
    .replace('YYYY', 'yyyy')
    .replace('MMM', 'MM');
  public colsTrades = [];

  constructor(
    private deviceService: DeviceDetectorService,
    private sessionService: SessionService,
    private profilePortfolioService: ProfileportfolioService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private currencyPipe: CurrencyPipe,
    private percentPipe: PercentPipe,
    private datePipe: DatePipe,
    private dashEmptyPipe: DashEmptyPipe
  ) {}

  @HostListener('window:resize') onresize() {
    this.isMobile = this.deviceService.isMobile();
    this.initTableColums();
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    this.initTableColums();

    this.isLoading = false;
    this.profilePortfolioService.getLiabilities();
    this.profilePortfolioService.portfolioanalysisCredits$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res) {
          this.data = res;
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  /**
    Función para crear las columnas en las tablas
  */
  initTableColums() {
    if (this.isMobile) {
      this.colsTrades = [
        {
          dataField: 'Name',
          width: '50%',
          cssClass: 'td-250',
          cellTemplate: 'templateMobile',
          hidingPriority: 0,
        },
      ];
    } else {
      this.colsTrades = [
        {
          dataField: 'Name',
          caption: this.translate.instant('k000036'),
          width: '100%',
          cellTemplate: 'templateName',
          hidingPriority: 1,
        },
        {
          type: 'detailExpand',
        },
      ];
    }
  }

  getColorById(id): string {
    return Utils.getColorById(id);
  }

  //#region rows

  /**
      Función para colocar un border a la izquierda en modo Desktop
    */
  onRowExpanded(e) {
    const grid = e.component;
    const row = grid.getRowIndexByKey(e.key);
    const el = grid.getRowElement(row)[0];
    const detail = grid.getRowElement(row + 1)[0];
    //const animArr = detail.getElementsByClassName('detailswrapper');
    //const anim = animArr[0];
    el.classList.add('borderleft');
    detail.classList.add('borderleft');
    //anim.classList.add('opendetails_animation');
    grid.selectRows(e.key);
  }

  /**
        Función para colocar un sombreado sobre la fila de la tabla
      */
  onRowClick(e) {
    const key = e.component.getKeyByRowIndex(e.rowIndex);
    const expanded = e.component.isRowExpanded(key);
    if (e.rowType != 'detail') {
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.command === 'expand') {
      e.cellElement.classList.remove('dx-datagrid-expand');
    }
  }

  onRowCollapsed(e) {
    const grid = e.component;
    grid.selectRows(e.key);
  }
  //#endregion

  /**
    Función para abrir popup del detalle modo mobile
  */
  openDetailPosition(item) {
    let items: TechTableInfoItemModel[] = [];
    items.push(
      new TechTableInfoItemModel(
        'k004013',
        this.dashEmptyPipe.transform(item.AsseType)
      )
    );

    items.push(
      new TechTableInfoItemModel(
        'k000133',
        this.currencyPipe.transform(item.AvailableBalance, item.Currency)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k004014',
        this.percentPipe.transform(item.InterestRate)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k004015',
        item.OpeningDate == '1900-01-01'
          ? this.dashEmptyPipe.transform('')
          : this.datePipe.transform(item.OpeningDate, this.dateFormat)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k004016',
        item.MaturiryDate == '1900-01-01'
          ? this.dashEmptyPipe.transform('')
          : this.datePipe.transform(item.MaturiryDate, this.dateFormat)
      )
    );
    var dialogData = new TechTableInfoModel(item.Name, items);

    const dialogRef = this.dialog.open(TechTableInfoModalComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      panelClass: [
        'dialogfluid-intocenter',
        'tranimate__animated',
        'tranimate__slideInRight',
      ],
      data: dialogData,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
}
